// Core React libraries import
import React, { useContext, useEffect, useState } from 'react';

// Core ANTD and 3rdparty libraries import

// EZ web-app import

// EZ web-app utils import

import { SubTab_CalendarLayout } from './subTabs/subTab_CalendarLayout';
import { SubTab_CalendarIntegration } from './subTabs/subTab_CalendarIntegration';
import { SubTab_CalendarManagement } from './subTabs/subTab_CalendarManagement';

// Page level styles
import './calendar-style.scss';
import { Col, Row, Tabs } from 'antd';

export default function CalendarTab(props: any) {
    return (
        <div className="ez-tab-calendar">
            <div className="mb-5 ez-sub-content-wrapper">
                <Row className="row-wrapper">
                    <Col span={24}>
                        <Tabs defaultActiveKey="my_calendar">
                            <Tabs.TabPane tab="My Calendar" key="my_calendar" closable={false}>
                                <SubTab_CalendarLayout />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                tab={
                                    <span className="calendar_integration-tabpane">
                                        Calendar Integration
                                    </span>
                                }
                                key="calendar_integration"
                                closable={false}
                            >
                                <SubTab_CalendarIntegration />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                tab={
                                    <span className="calendar_management-tabpane">
                                        Calendar Management
                                    </span>
                                }
                                key="calendar_management"
                                closable={false}
                            >
                                <SubTab_CalendarManagement />
                            </Tabs.TabPane>
                        </Tabs>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
